// Fonte dati unica — La Villa Gift Card
export const GIFT_BONUS_AMOUNT = 20;
export const GIFT_BONUS_DEADLINE_LABEL = '24 dicembre 2026';
export const GIFT_VALIDITY_LABEL = '30 settembre 2027';

export const GIFT_CARDS = [
  {
    amount: 50,
    nome: 'Un pensiero speciale',
    credito: '50 € da utilizzare alla Villa.',
    descrizione: 'Un piccolo regalo per concedersi un momento di relax.',
    cta: 'Regala 50 €',
  },
  {
    amount: 100,
    nome: 'Una giornata da condividere',
    credito: '100 € da utilizzare alla Villa.',
    descrizione: 'La libertà di scegliere tra piscina, aperitivi e momenti da vivere insieme.',
    badge: 'La nostra proposta',
    cta: 'Regala 100 €',
    featured: true,
  },
  {
    amount: 200,
    nome: 'Più estate, insieme',
    credito: '200 € da utilizzare alla Villa.',
    promo: "In più, 20 € di bonus dedicati all'aperitivo.",
    descrizione: 'Un regalo da vivere anche in più occasioni, con un brindisi in più.',
    badgeBonus: 'Bonus aperitivo incluso',
    cta: 'Regala 200 €',
  },
];

// Promo bonus aperitivo: acquisti entro il 24 dicembre 2026 incluso (Europe/Rome)
export function isAperitivoBonusActive(now = new Date()) {
  const romeDay = now.toLocaleDateString('sv-SE', { timeZone: 'Europe/Rome' });
  return romeDay <= '2026-12-24';
}

export const GIFT_FAQS = [
  {
    q: 'Come ricevo la Gift Card?',
    a: "Subito dopo il pagamento online sicuro (Nexi XPay) ricevi il buono digitale via email, con il codice univoco e la tua dedica. Puoi stamparlo o inoltrarlo direttamente a chi lo riceve.",
  },
  {
    q: 'Posso stamparla?',
    a: 'Sì. Il buono digitale può essere stampato oppure inoltrato direttamente a chi lo riceve.',
  },
  {
    q: 'Devo scegliere subito la data?',
    a: 'No. Chi riceve la Gift Card sceglie liberamente quando utilizzarla, durante le aperture della stagione 2027.',
  },
  {
    q: 'Posso utilizzarla in più occasioni?',
    a: 'Sì. Il credito può essere speso in più visite: il saldo residuo resta disponibile per le volte successive.',
  },
  {
    q: 'Posso pagare la differenza?',
    a: 'Sì. Se la spesa supera il saldo della Gift Card, la differenza si paga normalmente in struttura.',
  },
  {
    q: 'Posso usarla per un abbonamento?',
    a: "Sì. Il credito è utilizzabile per ingressi piscina, abbonamenti e consumazioni aderenti, alle tariffe applicabili al momento dell'acquisto del servizio.",
  },
  {
    q: 'Come funziona il bonus aperitivo?',
    a: "Con la Gift Card da 200 € richiesta entro il 24 dicembre 2026 ricevi 20 € extra dedicati esclusivamente all'aperitivo. Il bonus è separato dai 200 € di credito e non può pagare ingressi o abbonamenti.",
  },
  {
    q: 'Fino a quando è valida?',
    a: 'La validità proposta è fino al 30 settembre 2027, durante le aperture dei servizi aderenti.',
  },
  {
    q: 'Include la nuova palestra o la Jacuzzi?',
    a: "Non ancora. Palestra e nuove esperienze Jacuzzi non sono incluse nell'offerta attuale: eventuali utilizzi futuri saranno comunicati dopo l'effettiva attivazione dei servizi.",
  },
];

export const GIFT_RULES = [
  'Il credito acquistato è utilizzabile per ingressi piscina, abbonamenti e consumazioni aderenti.',
  'Il bonus aperitivo è separato dal credito acquistato e non può pagare ingressi o abbonamenti.',
  'Il credito può essere utilizzato in più occasioni: il saldo residuo resta disponibile.',
  'Se la spesa supera il saldo, è possibile pagare la differenza.',
  "Il credito è un importo monetario: i servizi vengono addebitati alle tariffe applicabili al momento dell'acquisto.",
  'La Gift Card non garantisce automaticamente un posto, un lettino riservato o una prenotazione.',
  'Restano applicabili disponibilità, calendario di apertura e regolamento della struttura.',
  'Validità proposta: fino al 30 settembre 2027, durante le aperture dei servizi aderenti.',
  "Palestra e nuove esperienze Jacuzzi non sono incluse nell'offerta attuale: eventuali utilizzi futuri saranno comunicati dopo l'effettiva attivazione dei servizi.",
];
